const MODULE_USER = {
  state: {
    isLogin: false,
    id: '',
    loginName: '',
    sex: '',
    userName: '',
    roles: [],
    role: '',
    cityId: '',
    areaId: '',
    schoolId: '',
    schoolName: '',
    gradeId: '',
    classId: '',
    userType: '',
    clientId: '',
    token: '',
    previewUrl: '',
    uploadUrl: '',
    currentDirectory: {},
    breadcrumb: "",
    sectionData: {}
  },

  getters: {
    userModule(state) {
      return state
    }
  },

  mutations: {
    saveuser(state, value) {
      state.isLogin = value.isLogin
      state.id = value.id
      state.loginName = value.loginName
      state.sex = value.sex
      state.userName = value.userName
      state.roles = value.roles
      state.role = value.role
      state.authPowerStrList = value.authPowerStrList
      state.userHeadImage = value.userHeadImage
      state.orgName = value.orgName
      state.region = value.region
      state.userType = value.userType
      state.areaId = value.areaId
      state.cityId = value.cityId
      state.schoolId = value.schoolId
      state.schoolName = value.schoolName
      state.gradeId = value.gradeId
      state.classId = value.classId
      state.clientId = value.clientId
      state.token = value.token
      state.previewUrl = value.previewUrl
      state.uploadUrl = value.uploadUrl
    },
    saveCurrentDirectory(state, value) {
      state.currentDirectory = value
    },
    saveBreadcrumb(state, value) {
      state.breadcrumb = value
    },
    saveSectionData(state, value) {
      state.sectionData = value
    }
  }
};

export { MODULE_USER };



// WEBPACK FOOTER //
// ./src/store/user-store.js